import React, { Suspense } from 'react'
import { Switch, Route, PersonalDataError } from '@fs/zion-router'
import ErrorBoundary from '@fs/zion-error-boundary'
import AppSkeleton from './components/AppSkeleton'
import PageWrapper from './components/PageWrapper'
import { ProviderSteps, Urls } from './constants'

// Dynamically load components to reduce bundle size
// https://reactjs.org/docs/react-api.html#reactlazy
const SignUpRoutes = React.lazy(() => import('./components/SignUpRoutes'))
const ProviderRoutes = React.lazy(() => import('./components/provider/ProviderRoutes'))
const InputConsentEmailStartPage = React.lazy(() => import('./components/consent/InputConsentEmailStartPage'))
const InputConsentCodeStartPage = React.lazy(() => import('./components/consent/InputConsentCodeStartPage'))
const EmailConsentStartPage = React.lazy(() => import('./components/consent/EmailConsentStartPage'))
const InputVerificationCodeStartPage = React.lazy(() => import('./components/InputVerificationCodeStartPage'))
const EmailVerificationFinishPage = React.lazy(() => import('./components/EmailVerificationFinishPage'))
const EmailVerificationStartPage = React.lazy(() => import('./components/EmailVerificationStartPage'))
const MobileSuccessPage = React.lazy(() => import('./components/MobileSuccessPage'))
const GenericErrorPage = React.lazy(() => import('./components/GenericErrorPage'))
const LocationAgeErrorPage = React.lazy(() => import('./components/LocationAgeErrorPage'))
const SessionExpiredPage = React.lazy(() => import('./components/SessionExpiredPage'))
const EmailVerificationExpiredPage = React.lazy(() => import('./components/EmailVerificationExpiredPage'))
const EmailVerificationSuccessPage = React.lazy(() => import('./components/EmailVerificationSuccessPage'))
const RedirectOnSuccessPage = React.lazy(() => import('./components/RedirectOnSuccessPage'))
const VerifyFsPage = React.lazy(() => import('./components/VerifyFsPage'))

function App() {
  return (
    <ErrorBoundary>
      <PageWrapper>
        <Suspense fallback={<AppSkeleton />}>
          <Switch>
            <Route path={ProviderSteps.START}>
              <ProviderRoutes />
            </Route>
            <Route exact path="/consent-landing" component={InputConsentEmailStartPage} />
            {/* Sign up via native mobile app provides a redirect to /mobile/success which normally will open a native view but we still need a success page just in case */}
            <Route exact path={Urls.MOBILE_SUCCESS} component={MobileSuccessPage} />
            <Route exact path="/parent-sms" component={InputConsentCodeStartPage} />
            <Route exact path="/parent-email" component={EmailConsentStartPage} />
            <Route exact path="/validate-sms" component={InputVerificationCodeStartPage} />
            <Route exact path="/validate-email" component={EmailVerificationStartPage} />
            <Route exact path="/verify" component={VerifyFsPage} />
            <Route exact path={Urls.VERIFY_EMAIL} component={EmailVerificationFinishPage} />
            <Route exact path={Urls.VERIFY_EMAIL_EXPIRED} component={EmailVerificationExpiredPage} />
            <Route exact path={Urls.VERIFY_EMAIL_SUCCESS} component={EmailVerificationSuccessPage} />
            <Route exact path={Urls.ERROR} component={GenericErrorPage} />
            <Route exact path={Urls.LOCATION_AGE_RESTRICTION} component={LocationAgeErrorPage} />
            <Route exact path={Urls.SESSION_EXPIRED} component={SessionExpiredPage} />
            <Route exact path="/validate" component={RedirectOnSuccessPage} />
            <Route exact path={Urls.FEATURE_UNAVAILABLE} component={PersonalDataError} />
            <Route component={SignUpRoutes} />
          </Switch>
        </Suspense>
      </PageWrapper>
    </ErrorBoundary>
  )
}
export default App
